import { AnalyticsBrowser } from '@segment/analytics-next';

export const useTracking = (user = null) => {
  const analytics = new AnalyticsBrowser();

  analytics.load({ writeKey: 'DtfAXdc0MLtVLA97kwcDLZnr4DYck1j9' });

  const identify = (type = 'client', model, properties = {}) => {
    if (process.env.REACT_APP_ENV !== 'prod') {
      return;
    }

    const modelId = `${model}-${model.id}-${process.env.REACT_APP_ENV}`;
    const companyId = `company-${model.company_id}-${process.env.REACT_APP_ENV}`;

    properties = {
      userType: type,
      userId: modelId,
      userFirstName: model.first_name,
      userLastName: model.last_name,
      userEmail: model.email,
      groupId: companyId,
      ...properties,
    };

    if (type == 'client') {
      analytics.identify(model.id, properties);
    } else {
      analytics.identify(properties);
    }
  };

  const trackEvent = (event, properties = {}) => {
    if (process.env.REACT_APP_ENV !== 'prod') {
      return;
    }

    if (user) {
      const userId = `${user}-${user.id}-${process.env.REACT_APP_ENV}`;
      const companyId = `company-${user.company_id}-${process.env.REACT_APP_ENV}`;

      properties = {
        ...properties,
        userId: userId,
        userFirstName: user.first_name,
        userLastName: user.last_name,
        userEmail: user.email,
        groupId: companyId,
      };
    }

    analytics.track(event, properties);
  };

  return { trackEvent, identify };
};
